import React, { useEffect, useState, useRef } from 'react';
import { TabOptions } from '../../../../../../../cronGeneratorState/cronGeneratorContext';
import { Radio, Select } from 'antd';
import Text from 'components/Text/Text';
import style from './EveryBetweenSelect.module.scss';

const { Option } = Select;

interface IEveryBetweenSelect {
	onSetResult: (value: string) => void;
}

interface IEveryBetweenSelectItem {
	name: string;
	value: string;
}

const EveryBetweenSelect: React.FC<IEveryBetweenSelect> = ({ onSetResult }) => {
	const parentNodeRef1 = useRef<null | HTMLDivElement>(null);
	const parentNodeRef2 = useRef<null | HTMLDivElement>(null);
	const everyBetweenValues: IEveryBetweenSelectItem[] = [
		{ name: 'January', value: '1' },
		{ name: 'February', value: '2' },
		{ name: 'March', value: '3' },
		{ name: 'April', value: '4' },
		{ name: 'May', value: '5' },
		{ name: 'June', value: '6' },
		{ name: 'July', value: '7' },
		{ name: 'August', value: '8' },
		{ name: 'September', value: '9' },
		{ name: 'October', value: '10' },
		{ name: 'November', value: '11' },
		{ name: 'December', value: '12' },
	];

	const [startValue, setStartValue] = useState<string>(everyBetweenValues[0].value);
	const [endValue, setEndValue] = useState<string>(everyBetweenValues[0].value);

	const result = `${startValue}-${endValue}`;

	useEffect(() => {
		onSetResult(result);
	}, [result]);

	return (
		<div className={style.radioField}>
			<Radio value={TabOptions.EVERY_BETWEEN_OPTION} id={TabOptions.EVERY_BETWEEN_OPTION + 'monthTab'} />
			<div className={style.selectContainer}>
				<label className={style.label} htmlFor={TabOptions.EVERY_BETWEEN_OPTION + 'monthTab'}>
					<Text translationNameSpace="form" translationKey="everyMonthBetweenMonthLabel" asFragment={true} />
				</label>
				<span ref={parentNodeRef1} style={{ position: 'relative' }} />
				<Select
					className={style.select}
					value={startValue}
					onChange={setStartValue}
					showArrow={true}
					getPopupContainer={() => parentNodeRef1.current as HTMLDivElement}
					listItemHeight={everyBetweenValues.length}>
					{everyBetweenValues.map((el) => (
						<Option className={style.listItem} value={el.value} key={el.value}>
							{el.name}
						</Option>
					))}
				</Select>
				<label className={style.label} htmlFor={TabOptions.EVERY_BETWEEN_OPTION + 'monthTab'}>
					<Text translationNameSpace="form" translationKey="andMonthLabel" asFragment={true} />
				</label>
				<span ref={parentNodeRef2} style={{ position: 'relative' }} />
				<Select
					className={style.select}
					defaultValue={endValue}
					onChange={setEndValue}
					showArrow={true}
					getPopupContainer={() => parentNodeRef2.current as HTMLDivElement}
					listItemHeight={everyBetweenValues.length}>
					{everyBetweenValues.map((el) => (
						<Option className={style.listItem} value={el.value} key={el.value}>
							{el.name}
						</Option>
					))}
				</Select>
			</div>
		</div>
	);
};

export default React.memo(EveryBetweenSelect);
